import { SINGLE_CHOICE, MULTI_CHOICE_QUESTIONS, SLIDER } from './questionTypes';

export const createNewQuestion = () => {
  return {
    id: new Date().getUTCMilliseconds().toString(),
    question: '',
    questionType: SINGLE_CHOICE,
    min: 0,
    max: 100,
    required: false,
    isNew: true,
    isUpdated: false,
    answers: [
      { answer: '', score: '' },
      { answer: '', score: '' },
      { answer: '', score: '' },
    ],
  };
};

export const validateSliderQuestionType = ({ min, max, id }, errors) => {
  if (
    min === '' ||
    max === '' ||
    parseInt(min, 10) > 1000000 ||
    parseInt(max, 10) > 1000000 ||
    parseInt(min, 10) < -1000000 ||
    parseInt(max, 10) < -1000000 ||
    parseInt(min, 10) >= parseInt(max, 10)
  ) {
    const minmaxid = max === '' || max > 1000000 || max < -1000000 ? '-max' : '-min';
    errors.push({
      focus: `question-${id}${minmaxid}`,
      message: 'Please enter valid slider min and max values',
    });
  }
};

export const validateQuestionType = ({ questionType, id }, errors, disabledQuestionTypes) => {
  if (!questionType) {
    errors.push({
      focus: `question-${id}`,
      message: 'Please select a question type or remove the question',
    });
  }

  if (disabledQuestionTypes.includes(questionType)) {
    errors.push({
      focus: `question-${id}`,
      message: 'Please change question type or remove question',
    });
  }
};

export const validateMultipleChoiceQuestionType = ({ id, answers }, surveyType, errors) => {
  if (answers.filter(({ answer }) => answer !== '').length < 2) {
    errors.push({
      focus: `question-${id}-answer1`,
      message: 'Please enter at least two choices',
    });
  }

  if (surveyType === 'quiz' && answers.filter(({ score }) => score > 0).length === 0) {
    errors.push({
      focus: `question-${id}-score1`,
      message: 'Please enter at least one score for your answers',
    });
  }
};

export const isQuestionInvalid = (question, surveyType, { disabledQuestionTypes = [] }) => {
  const errors = [];
  validateQuestionType(question, errors, disabledQuestionTypes);

  if (question.question === '') {
    errors.push({
      focus: `question-${question.id}`,
      message: 'Please enter question text',
    });
  }

  if (MULTI_CHOICE_QUESTIONS.includes(question.questionType)) {
    validateMultipleChoiceQuestionType(question, surveyType, errors);
  }

  if (question.questionType === SLIDER) {
    validateSliderQuestionType(question, errors);
  }

  return errors;
};

export default createNewQuestion;
